import {Map, List, fromJS} from 'immutable';
import axios from "axios/index";
import { toast } from "react-toastify";

if (sessionStorage.getItem("authToken")) {
    axios.defaults.headers.common['Auth-Token'] = sessionStorage.getItem("authToken");
}

export const types = {
    INIT: 'AREACONROLADMIN/INIT',
    FETCH_MODULES: 'AREACONROLADMIN/FETCH_MODULES',
    FETCH_MODULES_SUCCESS: 'AREACONROLADMIN/FETCH_MODULES_SUCCESS',
    FETCH_MODULE_ITEMS: 'AREACONROLADMIN/FETCH_MODULE_ITEMS',
    FETCH_MODULE_ITEMS_SUCCESS: 'AREACONROLADMIN/FETCH_MODULE_ITEMS_SUCCESS',
    FETCH_STORES: 'AREACONROLADMIN/FETCH_STORES',
    FETCH_STORES_SUCCESS: 'AREACONROLADMIN/FETCH_STORES_SUCCESS',
    FETCH_AREA_CONTROLLED_ITEMS: 'AREACONROLADMIN/FETCH_AREA_CONTROLLED_ITEMS',
    FETCH_AREA_CONTROLLED_ITEMS_SUCCESS: 'AREACONROLADMIN/FETCH_AREA_CONTROLLED_ITEMS_SUCCESS',
    SELECT_MODULE: 'AREACONROLADMIN/SELECT_MODULE',
    SELECT_STORE: 'AREACONROLADMIN/SELECT_STORE',
    UPDATE_MODULE_ITEM_QUERY: 'AREACONROLADMIN/UPDATE_MODULE_ITEM_QUERY',
    UPDATE_AREA_CONTROLLED_ITEM_QUERY: 'AREACONROLADMIN/UPDATE_AREA_CONTROLLED_ITEM_QUERY',
};

export const initialState = fromJS({
    modules: [],
    moduleItems: [],
    stores: [],
    areaControlledItems: [],
    selectedModule: '',
    selectedStore: '',
    moduleItemQuery: '',
    areaControlledItemQuery: ''
});

export default (state = initialState, action) => {
    switch (action.type) {
        case types.INIT:
            return state;
        case types.FETCH_MODULES_SUCCESS:
            return state.set('modules', fromJS(action.modules));
        case types.FETCH_MODULE_ITEMS_SUCCESS:
            return state.set('moduleItems', fromJS(action.moduleItems));
        case types.FETCH_STORES_SUCCESS:
            return state.set('stores', fromJS(action.stores));
        case types.FETCH_AREA_CONTROLLED_ITEMS_SUCCESS:
            return state.set('areaControlledItems', fromJS(action.items));
        case types.SELECT_MODULE:
            return state
                .set('selectedModule', fromJS(action.moduleName))
                .set('moduleItemQuery', '')
                .set('areaControlledItemQuery', '')
                .set('areaControlledItems', fromJS([]))
                .set('selectedStore', '');
        case types.SELECT_STORE:
            return state.set('selectedStore', fromJS(action.storeGln))
                .set('moduleItemQuery', '')
                .set('areaControlledItemQuery', '');
        case types.UPDATE_MODULE_ITEM_QUERY:
            return state.set('moduleItemQuery', fromJS(action.query));
        case types.UPDATE_AREA_CONTROLLED_ITEM_QUERY:
            return state.set('areaControlledItemQuery', fromJS(action.query));
        default:
            return state
    }
};

export const initialise = () => {
    return (dispatch) => {
        dispatch(fetchModules());
    }
};

export const fetchModules = () => {
    return function (dispatch) {
        const path = __API__ + '/api/ui/module';

        return axios.get(path)
        .then(response => {
            return response.data;
        })
        .then(modules => {
            dispatch(fetchModulesSuccess(modules));
        })
        .catch(error => {
            console.log(error);
            toast.error('Module konnten nicht geladen werden!');
        });
    }
};

export const fetchModulesSuccess = (modules) => {
    return {
        type: types.FETCH_MODULES_SUCCESS,
        modules: modules
    };
};

export const fetchModuleItems = () => {
    return function (dispatch, getState) {

        const {selectedModule} = getState().areacontrolAdmin.toJS();

        const path = __API__ + `/api/ui/module/${selectedModule}/item`;

        return axios.get(path)
            .then(response => {
                return response.data;
            })
            .then(moduleItems => {
                dispatch(fetchModuleItemsSuccess(moduleItems));
            })
            .catch(error => {
                console.log(error);
                dispatch(fetchModuleItemsSuccess([]));
            });
    }
};

export const fetchModuleItemsSuccess = (moduleItems) => {
    return {
        type: types.FETCH_MODULE_ITEMS_SUCCESS,
        moduleItems: moduleItems
    };
};

export const fetchStores = () => {
    return function (dispatch) {
        let path = __API__ + '/api/ui/store';

        return axios.get(path)
            .then(response => {
                return response.data;
            })
            .then(stores => {
                dispatch(fetchStoresSuccess(stores));
            })
            .catch(error => {
                toast.error('Stores konnten nicht geladen werden');
            });
    }
};

export const fetchStoresSuccess = (stores) => {
    return {
        type: types.FETCH_STORES_SUCCESS,
        stores: stores
    };
};

export const fetchAreaControlledItems = () => {
    return function (dispatch, getState) {
        const {selectedModule, selectedStore} = getState().areacontrolAdmin.toJS();

        const path = __API__ +
            `/api/ui/areacontrol/store/${selectedStore}/module/${selectedModule}`;

        return axios.get(path)
            .then(response => {
                return response.data;
            })
            .then(data => {
                dispatch(fetchAreaControlledItemsSuccess(data));
            })
            .catch(error => {
                toast.error('Flächengesteuerte Elemente konnten nicht geladen werden');
            });
    }
};

export const fetchAreaControlledItemsSuccess = (items) => {
    return {
        type: types.FETCH_AREA_CONTROLLED_ITEMS_SUCCESS,
        items: items
    };
};

export const selectModule = (moduleName) => {

    return function (dispatch) {
        dispatch({
            type: types.SELECT_MODULE,
            moduleName: moduleName
        });
    }
};

export const selectStore = (storeGln) => {

    return function (dispatch) {
        dispatch({
            type: types.SELECT_STORE,
            storeGln: storeGln
        });
        dispatch(fetchModuleItems());
        dispatch(fetchAreaControlledItems());
    }
};

export const updateModuleItemQuery = (query) => {
    return {
        type: types.UPDATE_MODULE_ITEM_QUERY,
        query: query
    };
};

export const updateAreaControlledItemQuery = (query) => {
    return {
        type: types.UPDATE_AREA_CONTROLLED_ITEM_QUERY,
        query: query
    };
};

export const placeModuleItemsUnderAreaControl = (gtins) => {
    return function (dispatch, getState) {

        const {selectedModule, selectedStore} = getState().areacontrolAdmin.toJS();

        const path = __API__ + '/api/ui/areacontrol/addmoduleitemstostore';
        const command = {
            storeGln: selectedStore,
            moduleName: selectedModule,
            gtins: gtins
        };

        return axios.post(path, command)
            .then(response => {
                dispatch(fetchModuleItems());
                dispatch(fetchAreaControlledItems());
            })
            .then(() => {
                toast.success('Artikel zur Flächensteuerung hinzugefügt');
            })
            .catch(error => {
                toast.error('Artikel konnten nicht zur Flächensteuerung hinzugefügt werden!');
            });
    }
};

export const removeFromAreaControl = (itemIdsToRemove) => {
    return function (dispatch) {
        const path = __API__ + '/api/ui/areacontrol/removeitemsfromstore';
        const command = {
            itemIdsToRemove: itemIdsToRemove
        };

        return axios.post(path, command)
            .then(response => {
                dispatch(fetchModuleItems());
                dispatch(fetchAreaControlledItems());
            })
            .then(() => {
                toast.success('Artikel wurden aus Flächensteuerung entfernt');
            })
            .catch(error => {
                toast.error('Artikel konnten nicht aus Flächensteuerung entfernt werden!');
            });
    }
};

//selectors
export const getUnassignedModuleItems = (state) => {
    if (!state.has('moduleItems')) {
        return List();
    }

    const moduleItems = state.get('moduleItems');
    const assignedAreaControlledItems = state.get('areaControlledItems');

    const unassignedModuleItems = moduleItems.filter((moduleItem => {
        const index = assignedAreaControlledItems.findIndex((acItem) => {
            return acItem.get('gtin') === moduleItem.get('article').get('gtin')
        });

        return (index === -1);
    }));

    if(!state.get('moduleItemQuery')) {
        return unassignedModuleItems;
    }

    const queryTokens = state.get('moduleItemQuery').split(' ');

    const searchProperties = [
        'article.erpIdno', 'article.gtin', 'article.name', 'article.vendorArticleNumber'
    ];

    return unassignedModuleItems.filter((item) => {
        return queryTokens.every((token) => {
            return searchProperties.some((propertyPath) => {
                let path = propertyPath.split('.');
                return item.getIn(path).toLowerCase().indexOf(token.toLowerCase()) > -1;
            });
        });
    })
};

export const getAreaControlledItems = (state) => {
    if (!state.has('areaControlledItems')) {
        return List();
    }

    if(!state.get('areaControlledItemQuery')) {
        return state.get('areaControlledItems');
    }

    const queryTokens = state.get('areaControlledItemQuery').split(' ');

    const searchProperties = [
        'erpIdno', 'gtin', 'articleDetails', 'vendorArticleNumber'
    ];

    const areaControlledItems = state.get('areaControlledItems');

    return areaControlledItems.filter((item) => {
        return queryTokens.every((token) => {
            return searchProperties.some((propertyPath) => {
                let path = propertyPath.split('.');
                return item.getIn(path).toLowerCase().indexOf(token.toLowerCase()) > -1;
            });
        });
    })
};


// WEBPACK FOOTER //
// ./src/admin/areacontrol/admin/reducer.js